import './assets/main.css';
import './scss/main.scss';

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import './assets/fontawesome-free-6.4.2-web/js/all.min.js'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/popper.min.js';
//import './assets/fontawesome-free/js/all.min.js'


createApp(App).use(store).use(router).mount("#app");
